<template>
    <div class="head vue-view-header" ref="headerElement">
        <SidebarMenu :showDim="props.showDim" />
        <div class="logo">tastier</div>
        <slot></slot>
        <UserMenu />
    </div>
</template>

<script setup lang="ts">
    import SidebarMenu from "@/operator/components/layout/SidebarMenu.vue";
    import UserMenu from "@/operator/components/layout/UserMenu.vue";

    // Props
    const props = withDefaults(
        defineProps<{
            showDim?: boolean;
        }>(),
        {
            showDim: true,
        }
    );
</script>

<style lang="scss">
    .vue-view-header {
        display: flex;
        align-items: center;
        pointer-events: all !important;

        .logo {
            position: relative !important;

            &:not(:first-child) {
                padding-left: 16px !important;
            }
        }
    }
</style>
